import BaseService from "@/services/BaseService";
import * as URI from "../configuration/constant";

const action = {
  async getConfigurationTypes({ commit }, payload) {
    let url = URI.CONFIGURATION_TYPES_LIST.replace(
      "{divisionId}",
      payload.division
    )
      .replace("{audience}", payload.incentiveAudience)
      .replace("{channelIds}", payload.channelIds);
    const configuration = await BaseService.getSchemePlanningClient().get(url);
    return configuration.data.data;
  },

  async getConfigurationHeaders({ commit }, payload) {
    let url = "";
    if (payload.url == "daysCheckDTOList") {
      url = URI.GET_CONFIGURATION_DAYS_CHECK_GRID.replace(
        "{configId}",
        payload.configurationType
      ).replace("{journalTypeUrl}", payload.url);
    } else {
      url = URI.GET_CONFIGURATION_GRID.replace(
        "{configId}",
        payload.configurationType
      ).replace("{journalTypeUrl}", payload.url);
    }
    const configurationDefinition =
      await BaseService.getSchemePlanningClient().get(url);
    commit("setConfigurationFilters", payload);
    return configurationDefinition.data.data;
  },

  async createConfigurationData({ commit }, payload) {
    let configData = URI.CONFIGURATION_POST_PAYLOAD;
    configData.tableIdentifier = payload.identifier;
    configData[payload.identifier] = payload.data;
    const response = await BaseService.getSchemePlanningClient().post(
      URI.CREATE_CONFIGURATION_DATA,
      configData
    );
    return response.data;
  },

  async deleteConfigurationData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.DELETE_CONFIGURATION_DATA,
      {
        data: payload,
      }
    );
    return response.data;
  },

  async downloadAchievementClubbingData({ commit }, payload) {
    let url = URI.ACHIEVEMENT_CLUBBING_EXPORT.replace(
      "{configId}",
      payload.configurationType
    );
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },

  async importAchievementClubbingData({ commit }, payload) {
    let url = URI.ACHIEVEMENT_CLUBBING_IMPORT.replace(
      "{configId}",
      payload.configurationType
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.file,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  async getSubCategoryConfigurationListing({ commit }, payload) {
    let url = URI.GET_SUB_CATEGORY_LIST.replace("{budgetId}", payload.budgetId);
    const configurationDefinition =
      await BaseService.getSchemePlanningClient().get(url);
    return configurationDefinition.data.data;
  },

  async getWhatsAppRoleConfigListing({ commit }, payload) {
    let url = URI.GET_WHATAPP_CONFIG_LIST.replace("{configMstId}", payload.configMstId);
    const configurationDefinition =
      await BaseService.getSchemePlanningClient().get(url);
    return configurationDefinition.data.data;
  },

  async createHeaderFooterDetails({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.CREATE_CONFIG_HEADER_FOOTER,
      payload
    );
    return response.data;
  },

  setAchievementClubbingData({ commit }, payload) {
    commit("setAchievementClubbingData", payload);
  },

  setProDataSetupData({ commit }, payload) {
    commit("setProDataSetupData", payload);
  },
  async getBranchesAction({ commit }, payload) {
    let url = URI.GET_ALL_BRANCH_OPTIONS_URL.replace("{configId}", payload);
    const branchOptions = await BaseService.getSchemePlanningClient().get(url);
    commit("setBranchOptions", branchOptions.data.data);
    return branchOptions.data.data;
  },
  async smartSearchUserNameFunction({ commit }, payload) {
    const url = URI.USER_NAME_SMART_SEARCH_CODE_URL.replace(
      "{userId}",
      payload.userCode
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async smartSearchJobsRoleFunction({ commit }, payload) {
    const url = URI.CONFI_JOB_ROLE_SMART_SEARCH_CODE_URL.replace(
      "{searchKey}",
      payload.searchKey
    ).replace("{configMstId}", payload.configMstId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async createCommunicationSalesConfigurationData({ commit }, payload) {
    let configData = URI.CONFIGURATION_POST_PAYLOAD;
    configData.tableIdentifier = payload.identifier;
    configData[payload.identifier] = payload.data;
    let url = URI.CREATE_COMMUNICATION_SALES_CONFIGURATION_DATA.replace(
      "{division}",
      payload.division
    ).replace("{channel}", payload.channel);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      configData
    );
    return response.data;
  },
  async deleteCommunicationSalesConfigurationData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.DELETE_CONFIGURATION_DATA,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async getPurposeList({ commit }, payload) {
    const url = URI.GET_PURPOSE_LIST.replace("{channel}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response;
  },
  async getJobList({ commit }, payload) {
    const url = URI.GET_JOB_LIST.replace("{hrchyId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setJobLists", response.data.data);
    return response.data.data;
  },
  async getGroupTypeList({ commit }, payload) {
    const url = URI.GET_GROUP_TYPE_LIST.replace("{hrchyId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setGroupTypeList", response.data.data);
    return response.data.data;
  },
  async gethoGroupIdList({ commit }, payload) {
    const url = URI.GET_HO_GROUP_LISTS.replace("{division}", payload.division);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response;
  },
  async forRegionConfigurationDataAction({ commit }, payload) {
    const url = URI.REGION_CONFIGURATION.replace(
      "{configMstId}",
      payload.configMstId
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response;
  },
  async smartSearchEmailIdData({ commit }, payload) {
    const url = URI.GET_EMAIL_ID_LIST.replace("{emailId}", payload.emailId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async downloadConfigruationPayoutSenderData({ commit }, payload) {
    let url = URI.DOWNLOAD_CONFIGURATION_PAYOUT_SENDER.replace(
      "{configMstId}",
      payload.configMstId
    );
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async uploadConfigurationPayoutSenderCsv({ commit }, payload) {
    const url = URI.UPLOAD_CONFIGURATION_PAYOUT_SENDER;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
};

export default action;
